import { useCallback } from "react";
import type { SortableField } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks.ts";
import SelectFieldInput from "./SelectFieldInput.tsx";

interface Props {
  availableFields: SortableField[];
  disabled: boolean;
}

export const SelectSortFieldInput = ({ availableFields, disabled }: Props) => {
  const dispatch = useAppDispatch();

  const addFieldToSort = useCallback(
    (field: SortableField) => dispatch(fieldsStateActions.addSorting(field)),
    [dispatch]
  );

  return <SelectFieldInput onAddField={addFieldToSort} availableFields={availableFields} disabled={disabled} />;
};

export default SelectSortFieldInput;
